module.exports = [{
      plugin: require('/Users/RyanTeliczan/Devel/RTWS-gatsby-2/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
